// import Vue from 'vue';
import colorPicker from "./components/color-picker.vue";
// import "jquery-ui-touch-punch";

if ($("#vue-consultant").length) {
    new Vue({
        el: "#vue-consultant",
        components: {
            colorPicker
        },
        data: {
            mainColor: "#3143c9",
            value: 233,
            saturation: 61,
            lightness: 49,
            
        },
        methods: {
            onChangeColor(color) {
                this.mainColor = color;
            }
        }
    })
}



// WEBPACK FOOTER //
// ./vue/consultant.js